<template>
  <div>
    <!-- ヘッダー -->
    <TheMyticketHeader
      :ticketName="displaySheetName(bookGroup, masterSheet)"
      :clickBackButtonEvent="returnNativeApp"
    />

    <!-- 背景画像を適応タグ -->
    <div class="bg-img">
      <!-- 上部表示 -->
      <TheSheetUpper
        :isInIntervalFlag="props.isInIntervalFlag"
        :nextTimeAvailable="props.nextTimeAvailable"
      />

      <!-- ドットの線 -->
      <TheDotLine />

      <!-- 下部表示 -->
      <TheSheetLower :isInIntervalFlag="props.isInIntervalFlag" />
    </div>

    <!-- インターバル中のため使用不可ダイアログ -->
    <DialogInvalidFrameInInterval ref="DialogInvalidFrameInInterval" />
  </div>
</template>

<script>
// Vue
import { onMounted, computed, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";


export default {
  name: "TemplateSheet",
  props: {
    isInIntervalFlag: {
      type: Boolean,
      required: false,
    },
    nextTimeAvailable: {
      type: String,
      required: false,
      default: "",
    },
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();

    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const masterSheet = computed(() => store.getters["ticketing/masterSheet"]);
    const masterBook = store.getters["ticketing/masterBook"];
    const book = store.getters["ticketing/book"];


    const DialogInvalidFrameInInterval = ref(null);

    onMounted(async () => {
      // インターバル中なら使用不可ダイアログを表示
      if (props.isInIntervalFlag) {
        DialogInvalidFrameInInterval.value.openDialog();
      }
    });

    return {
      bookGroup,
      masterSheet,
      DialogInvalidFrameInInterval,
      props,
    };
  },
};
</script>
